import algoliasearch from 'algoliasearch/lite'
import instantsearch from 'instantsearch.js'
import { index } from 'instantsearch.js/es/widgets'
import customAutocomplete from './autocomplete.js'

const searchBox = $('#header-search-keyword')
const suggestionsContainer = $('#header-search-suggestions-container')

if (searchBox.length && suggestionsContainer.length && $('#search-index-name').val()) {
  const searchClient = algoliasearch('L39T1QHT93', 'c8189673c1e22052b2958f5d5ffe2d9a')
  const indexName = $('#search-index-name').val()

  const search = instantsearch({
    indexName: indexName + '_query_suggestions',
    searchClient,
  });

  search.addWidgets([
    customAutocomplete({
      searchBox,
      suggestionsContainer
    })
  ]);

  search.start();
}
